import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Controller } from "react-hook-form";
const Holder = ({ value, onChange, }) => null;
const HiddenField = ({ name, required, }) => _jsx(Controller, { as: Holder, required: required, name: name });
export default HiddenField;
